var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2048 1536",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 1080,
    width: 2048,
    height: 25,
    fill: "#1c1c1c"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1c1c1c"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 1105,
    width: 20,
    height: 140
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 1105,
    width: 20,
    height: 140
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 1105,
    width: 20,
    height: 140
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 1105,
    width: 20,
    height: 140
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 1105,
    width: 20,
    height: 140
  }), /*#__PURE__*/React.createElement("rect", {
    x: 600,
    y: 1105,
    width: 20,
    height: 140
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 1105,
    width: 20,
    height: 140
  }), /*#__PURE__*/React.createElement("rect", {
    x: 840,
    y: 1105,
    width: 20,
    height: 140
  }), /*#__PURE__*/React.createElement("rect", {
    x: 960,
    y: 1105,
    width: 20,
    height: 140
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 1105,
    width: 20,
    height: 140
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1200,
    y: 1105,
    width: 20,
    height: 140
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1320,
    y: 1105,
    width: 20,
    height: 140
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1440,
    y: 1105,
    width: 20,
    height: 140
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1560,
    y: 1105,
    width: 20,
    height: 140
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1680,
    y: 1105,
    width: 20,
    height: 140
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1800,
    y: 1105,
    width: 20,
    height: 140
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1920,
    y: 1105,
    width: 20,
    height: 140
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2040,
    y: 1105,
    width: 20,
    height: 140
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.77e24f3d0eb086b38a8a031780465122.svg";
export { ForwardRef as ReactComponent };